PJQ.views.budget.AddBudgetLineItemsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'modal-add-line-items'),
        width: '90%',
        maxWidth: 1200,
        isShowCloseButton: true,
        onSave: _.noop,
        isAdmin: true
    },
    events: {
        'click .go-to-cost-codes': 'goToCostCodes',
        'click .btn-save': 'save',
        'click .btn-cancel': 'cancel'
    },
    beforeModalCreated: async function () {
        this.collection = new PJQ.collections.budget.LineItems();
        this.accountingMethod = 0;
        this.options.project = PJQ.app.session.project;

        this.isFetched = false;
        this.costCodes = await this.options.project.fetchCostCodes();
        this.costTypes = await this.options.project.fetchCostTypes();
        this.unitsOfMeasure = await this.options.project.fetchUnitsOfMeasure();
        this.isFetched = true;
        this.render();
    },
    renderData: function () {
        return {
            collection: this.collection,
            costCodes: this.costCodes != null ? this.costCodes.models : [],
            costTypes: this.costTypes != null ? this.costTypes.models : [],
            unitsOfMeasure: this.unitsOfMeasure != null ? this.unitsOfMeasure.models : [],
            accountingMethod: this.accountingMethod
        }
    },
    afterRender: function () {
        this.renderLineItemsView();
    },
    renderLineItemsView: function () {
        if(this.lineItemsView){
            this.lineItemsView.remove();
        }
        
        this.lineItemsView = new PJQ.views.budget.LineItemsView({
            el: this.$('.line-items-view'),
            collection: this.collection,
            lineItemModel: PJQ.models.budget.LineItem,
            accountingMethod: 0,
            canEdit: true,
            canDelete: true,
            canChangeAccountingMethod: true,
            isBudget: true,
            onAccountingMethodChanged: _.bind(function (value) {

            }, this),
            onLineItemAdd: _.bind(function () {

            }, this),
            onLineItemDelete: _.bind(function () {

            }, this)
        });
    },
    importLineItems: function () {
        let $uploader = this.$('.import-uploader');
        if (this.fileUploader == null) {
            this.fileUploader = new PJQ.views.files.FileUploaderGrid({
                el: $uploader,
                useApiV2: true,
                allowedExtensions: ['xls', 'xlsx', 'csv'],
                maxFiles: 1,
                style: 'grid',
                onSuccess: _.bind(function (file) {
                    let loader = new PJQ.Loader($uploader);
                    if (this.options.budget != null && _.size(file.uploadId) > 0) {
                        this.options.budget.processImport(file.uploadId, _.bind(function (data) {
                            this.fileUploader.remove();
                            loader.remove();
                            this.fileUploader = null;
                            this.collection.add(data);
                            this.renderLineItems();
                        }, this));
                    }
                }, this)
            });
        } else {
            // Hide file uploader if button is clicked again
            $uploader.attr('hidden', !$uploader.attr('hidden'));
        }
    },
    goToCostCodes: function () {
        PJQ.app.router.navigate("projects/" + (this.options.project.id).toString() + "/costcodes", {
            trigger: true
        });
        this.removeModal();
    },
    save: function () {
        if (this.lineItemsView.validate()) {
            this.options.budget.addLineItems(this.collection.models, _.bind(function () {
                this.options.onSave(this.collection.models);
                this.removeModal();
            }, this));
        }
    },
    cancel: function () {
        if (_.size(this.collection.models) > 0) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.save();
                }, this),
                onDontSave: _.bind(function () {
                    this.removeModal();
                }, this)
            });
        } else {
            this.removeModal();
        }
    }
});


PJQ.views.budget.EditLineItemBudgetModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'modal-edit-line-item-budget'),
        maxWidth: 600,
        isShowCloseButton: true,
        onSave: _.noop,
        isAdmin: true
    },
    events: {
        'focus .input-dollars-full,.input-percent,.input-hours': 'selectInput',
        'keyup .input-quantity, .input-unit-price': 'calculateUnitTotal',
        'click .btn-save': 'save',
        'click .btn-cancel': 'cancel'
    },
    beforeModalCreated: function () {
        this.isFetched = false;
        PJQ.app.session.project.fetchSubJobs(_.bind(function (subJobs) {
            this.subJobs = subJobs;
            PJQ.app.session.project.fetchCostCodes(_.bind(function (costCodes) {
                this.costCodes = costCodes;
                PJQ.app.session.project.fetchCostTypes(_.bind(function (costTypes) {
                    this.costTypes = costTypes;
                    PJQ.app.session.project.fetchUnitsOfMeasure(_.bind(function (unitsOfMeasure) {
                        this.unitsOfMeasure = unitsOfMeasure;

                        this.isFetched = true;
                        this.render();
                    }, this));
                }, this));
            }, this));
        }, this));
    },
    renderData: function () {
        return {
            model: this.model,
            budget: this.options.budget,
            subJobs: this.subJobs != null ? this.subJobs : [],
            costCodes: this.costCodes != null ? this.costCodes : [],
            costTypes: this.costTypes != null ? this.costTypes : [],
            unitsOfMeasure: this.unitsOfMeasure != null ? this.unitsOfMeasure.models : [],
            isFetched: this.isFetched
        }
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        new PJQ.Binder(this.$el, this.model, {
            watchElements: [
                'input'
            ],
            useDecimalPercentFields: true,
        });

        PJQ.helpers.inputHelpers.inputMaskDecimal(this.$('.input-hours'), 1);

        new PJQ.inputs.Selectpicker({
            el: this.$('.select-accounting-method'),
            defaultValue: this.model.get('accountingMethod'),
            isIntChoices: true,
            onChange: _.bind(function (value) {
                this.setAccountingMethod(value);
            }, this)
        });

        this.unitOfMeasureSelector = new PJQ.inputs.Selectpicker({
            el: this.$('.select-unit-of-measure'),
            defaultValue: this.model.get('unitId'),
            isIntChoices: true,
            hideDisabled: true
        });

        PJQ.helpers.inputHelpers.inputMaskCurrency(this.$('.input-dollars-full'), 2, true);
        PJQ.helpers.inputHelpers.inputMaskDecimal(this.$('.input-quantity'), 2);
        this.calculateUnitTotal();
    },
    selectInput: function (e) {
        let el = $(e.currentTarget)[0];
        if (this.focusInput !== el) {
            this.focusInput = el;
            setTimeout(_.bind(function () {
                this.focusInput.select();
            }, this), 100);
        }
    },
    calculateUnitTotal: function () {
        let unitPrice = PJQ.helpers.inputHelpers.getMoneyInputValue(this.$('.input-unit-price').parent()),
            quantity = parseFloat(this.$('.input-quantity').val());
        this.$('.unit-total').html(PJQ.helpers.formatHelpers.formatCurrency(quantity * unitPrice));
    },
    setAccountingMethod: function (method) {
        this.model.set('accountingMethod', method);
        this.render();
    },
    save: function () {
        if (this.model.get('accountingMethod') === 0) {
            let budgetedCost = PJQ.helpers.inputHelpers.getMoneyInputValue(this.$('.input-budgeted-cost'));
            this.model.set('budgetedCost', budgetedCost != null ? budgetedCost : 0);
        } else {
            let quantity = this.$('.input-quantity').val(),
                unitPrice = PJQ.helpers.inputHelpers.getMoneyInputValue(this.$('.input-unit-price'));
            this.model.set({
                unitId: this.unitOfMeasureSelector.getValue(),
                quantity: _.size(quantity) > 0 ? parseFloat(quantity) : 0,
                unitPrice: unitPrice != null ? unitPrice : 0
            })
        }

        let $hours = this.$('.input-budgeted-hours');
        this.model.set('budgetedHours', Math.ceil(parseFloat($hours.val()) * 60));

        this.model.save(null, {
            success: _.bind(function () {
                this.options.onSave(this.model);
                this.removeModal();
            }, this)
        }, this);
    },
    cancel: function () {
        this.model.restore();
        this.removeModal();
    }
});
